import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Euro } from 'lucide-react';

export const PricingSection = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="tarif" className="py-32 bg-white relative">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto fade-in-section">
          <h2 className="section-title mb-12 text-center">
            Une décision claire avant d'engager<br />
            davantage de <span className="text-accent">budget</span>
          </h2>

          <div className="bg-gray-50 border-2 border-gray-200 rounded-2xl overflow-hidden">
            {/* Prix principal */}
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 p-12 text-center">
              <p className="text-white/80 text-sm uppercase tracking-wider mb-4">
                Gap de Perception
              </p>
              <div className="flex items-center justify-center gap-2 mb-4">
                <span className="text-6xl font-bold text-white">700</span>
                <span className="text-3xl text-white/80">€</span>
              </div>
              <p className="text-white/60 text-sm">
                Phase de diagnostic et restitution
              </p>
            </div>

            {/* Description */}
            <div className="p-8 space-y-6">
              <p className="text-gray-700 leading-relaxed text-lg">
                Le Gap de Perception constitue la première phase de l'intervention.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Son rôle est d'éviter de refondre un site, un discours, une identité ou des supports sans avoir déterminé précisément ce qui mérite réellement d'être corrigé.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Le tarif inclut la phase de diagnostic et sa restitution.
              </p>
              
              <div className="pt-6 border-t border-gray-200">
                <p className="text-gray-700 leading-relaxed font-medium">
                  La création, la réécriture complète, la refonte ou le déploiement des recommandations ne sont pas inclus. Ces travaux peuvent faire l'objet d'un devis séparé selon les besoins révélés.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="p-8 bg-gray-100 text-center">
              <Button
                onClick={scrollToContact}
                className="cta-button group"
                size="lg"
              >
                Échanger sur votre situation
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
